<script setup lang="ts">
import type { DashboardFormSchema } from '@/views/forms/schema.ts'
import { dashboardSchema } from '@/views/forms/schema.ts'

const OMNI_ADMIN_URL = import.meta.env.VITE_OMNI_ADMIN_URL

defineProps<{
  dashboard: DashboardFormSchema
  removeDashboard: () => void
  name: string
}>()
</script>
<template>
  <UForm :schema="dashboardSchema" :name="name" nested>
    <UFieldGroup class="items-start">
      <UFormField name="title">
        <UInput
          placeholder="Dashboard title"
          v-model="dashboard.title"
          :ui="{ base: 'rounded-r-none' }"
        />
      </UFormField>
      <UFormField name="dashboard_url">
        <UInput
          v-model="dashboard.dashboard_url"
          placeholder="/chat, /dashboards/<id>, /apps/<id>, or /w/<id>/duplicate"
        />
      </UFormField>
      <UButton
        @click="removeDashboard"
        color="error"
        icon="i-lucide-circle-x"
        variant="subtle"
        :ui="{ base: 'rounded-none' }"
      />
      <UButton
        :to="dashboard.dashboard_url ? `${OMNI_ADMIN_URL}${dashboard.dashboard_url}` : undefined"
        target="_blank"
        icon="i-lucide-external-link"
        variant="subtle"
        :disabled="!dashboard.dashboard_url"
        :ui="{ base: 'rounded-l-none' }"
      />
    </UFieldGroup>
  </UForm>
</template>
